const ID_AGENT_KEY = "id_agent";

export const getAgent = () => {
  try {
    return JSON.parse(window.localStorage.getItem(ID_AGENT_KEY));
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const saveAgent = agent => {
  if (agent) {
    window.localStorage.setItem(ID_AGENT_KEY, JSON.stringify(agent));
  } else {
    window.localStorage.removeItem(ID_AGENT_KEY);
  }
};

export default { getAgent, saveAgent };
